import { Component, OnInit } from '@angular/core';
import { ScreenService } from '@services/screen.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent implements OnInit {
  title = 'app';

  constructor(
    public screenService: ScreenService) {
  }

  ngOnInit() {
    this.screenService.isShowLoader = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts